import type { Branding } from '@logto/schemas'
import { Theme } from '@logto/schemas'
import type { Nullable } from '@silverhand/essentials'

const defaultLogtoLogoUrls = new Set(['https://logto.io/logo.svg', 'https://logto.io/logo-dark.svg'])

const withoutDefaultLogtoLogo = (url?: Nullable<string>) => (url && !defaultLogtoLogoUrls.has(url) ? url : null)

export type GetLogoUrl = {
  theme: Theme
  logoUrl: string
  darkLogoUrl?: Nullable<string>
}

export const getLogoUrl = ({ theme, logoUrl, darkLogoUrl }: GetLogoUrl) => {
  if (theme === Theme.Dark) {
    return darkLogoUrl ?? logoUrl
  }

  return logoUrl
}

export type GetBrandingLogoUrl = {
  theme: Theme
  branding: Branding
  isDarkModeEnabled: boolean
}

export const getBrandingLogoUrl = ({ theme, branding, isDarkModeEnabled }: GetBrandingLogoUrl) => {
  const logoUrl = withoutDefaultLogtoLogo(branding.logoUrl)
  const darkLogoUrl = withoutDefaultLogtoLogo(branding.darkLogoUrl)

  if (!isDarkModeEnabled) {
    return logoUrl
  }

  if (!logoUrl && !darkLogoUrl) {
    return null
  }

  if (logoUrl && darkLogoUrl) {
    return getLogoUrl({ theme, logoUrl, darkLogoUrl })
  }

  return logoUrl ?? darkLogoUrl
}
